export default "__VITE_ASSET__DjemXTQQ__"